export const showAlert = (data) => {
    return {
        type: "SHOW_ALERT",
        payload: data,
    };
};
